// extracted by mini-css-extract-plugin
export default {"modal_wrap":"modalContent_modal_wrap__Jyd52","confirm_button":"modalContent_confirm_button__Dikae","cancel_button":"modalContent_cancel_button__NGReO"};